import React from 'react';

import { FileUploadIcon } from './FileUploadIcon';

export const FileUploadDisabledIcon = () => {
  return <FileUploadIcon disabled />;
};
